import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/seo"
import { Router } from "@reach/router"
import TermsAndPrivacy from "../../components/termsAndPrivacy"

const termsandprivacypage = () => {
  return (
    <Layout pageTitle={""}>
      <SEO title="Terms of use and privacy" />
      <TermsAndPrivacy />
    </Layout>
  )
}

export default termsandprivacypage
